import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

export interface CheckboxOption {
  value: string;
  labelKey: string;
  checked?: boolean;
}

@Component({
  selector: 'app-data-filter-checkbox',
  templateUrl: './data-filter-checkbox.component.html',
  styleUrls: ['./data-filter-checkbox.component.scss']
})
export class DataFilterCheckboxComponent implements OnInit, OnChanges {

  @Input()
  name: string;

  @Input()
  labelKey: string;

  @Input()
  options: CheckboxOption[] = [];

  @Input()
  model: string[];

  @Output()
  modelChange = new EventEmitter<string[]>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.model && changes.model.currentValue) {
      this.options.map(o => o.checked = this.model.includes(o.value));
    }
  }

  change() {
    this.model = this.options.filter(o => o.checked).map(o => o.value);
    this.modelChange.emit(this.model);
  }
}
